<template>
  <div>
    <b-alert v-if="false" id="status" variant="danger" show> Kameraya Bağlanılamadı </b-alert>
    <div v-if="false" class="animation-handlers">
      <b-button variant="primary" @click="start">{{$t('account.map.start')}}</b-button>
      <b-button variant='danger' @click="stop">{{$t('account.map.stop')}}</b-button>
      <b-button variant='warning' @click="reset">{{$t('account.map.reset')}}</b-button>
    </div>
    <video id="video" ref="video" width="1000" height="550" controls autoplay> </video>
  </div>
</template>
<script>
import jwt_decode from "jwt-decode";
let ms;
let sourceBuffer;
let unwatch;
export default {
  name: 'Cameras',
  props:{
    data: Object,
    save: Boolean,
    saveState: Function,
    modalEvent: Function,
  },
  mounted: function(){
    console.log('Bağlanacağım',this.$store.state)
    ms = new MediaSource();
    ms.addEventListener('sourceopen', this.opened, false);
    this.$refs.video.src = window.URL.createObjectURL(ms);
    console.log( this.$refs.video.src)
     if(unwatch){
      unwatch();
      sourceBuffer && sourceBuffer.abort()
     } 
     unwatch = this.$store.watch(
      (state)=>{
        return this.$store.state.Socket
      },
      (val)=>{
        console.log(val)
        if(val.camera){
          this.streamCamera(val.camera)
        } 
      },
      {
        deep:true,
        immediate: true
      }
    );
    
  },
  created: function(){
    console.log('İzle')
    
  },
  data() {
    return {
      streamingStarted: false,
      loading: false,
      queue: [],
      sourceBuffer: undefined
    }
  },
  watch:{
    save: function(data){
      if(data){
        console.log('SaveState',data)
        this.closed()
        this.saveState(false)
        this.modalEvent(false)
      }
    }
  },

  methods:{
    opened: function(){
     
   
    },
    closed: function(){
      console.log('Camerayı Kopar')
        let params =  {
           "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
            "uuid": this.data.link_id,
            "event" : "disconnect_camera",
        }
        this.$socket.send(JSON.stringify(params))
   
    },
    streamCamera: function(cam){
        let data; // = new Uint8Array(cam.data);
        var mimeCodec;
        cam.arrayBuffer().then(ab => {
          data = new Uint8Array(ab);
          if (data[0] == 9) {
            let decoded_arr = data.slice(1);
            if (window.TextDecoder) {
              mimeCodec = new TextDecoder("utf-8").decode(decoded_arr);
            } 
              sourceBuffer = ms.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"');
              console.log('Source Buffer Oluştu', sourceBuffer)

              if(sourceBuffer){
                sourceBuffer.mode = "segments"
                sourceBuffer.addEventListener("updateend", this.loadPacket);
              }
          } else {
            this.pushPacket(ab);
          }
        }) 
    },
    loadPacket: function(){
      if (sourceBuffer && !sourceBuffer.updating) {
        if( this.queue.length > 0) {
          let inp = this.queue.shift();
          console.log(inp, sourceBuffer)
          sourceBuffer.appendBuffer(inp);
        } else {
          this.streamingStarted = false;
        }
      }
    },
    pushPacket: function(arr){
      let data = arr;
      if (!this.streamingStarted) {
        sourceBuffer && sourceBuffer.appendBuffer(data);
        this.streamingStarted = true;
        return;
      }

      this.queue.push(data);
      
      if (sourceBuffer && !sourceBuffer.updating) {
        this.loadPacket();
      }
    }
  }
};
</script>
<style scopped>
.animation-handlers {
  text-align: right;
  margin-bottom: 1rem;
}


@keyframes pulsate {
  0% { opacity: 0.0;}
  50% {opacity: 0.5;}
  75% { opacity: 1.0;}
  100% {opacity: 0.5;}
}

</style>


// WEBPACK FOOTER //
// src/components/Cameras.vue